import {
  Project,
  Header,
  EndProject,
  OnGoingProject,
  getHeader,
  getProjectList,
  getOnGoingProjectList,
  getEndProjectList,
} from '@/apis';
import { useEffect } from 'react';
import { useVisible } from '@/hooks/visible';
import { usePagination } from '@/hooks/pagination';
import { useDeadpool, DEADPOOLKEYS } from '@spot-fe/base-hooks';
import { useList } from './store';

export const useData = () => {
  // head loading
  const headLoading = useVisible(true);
  // ongoing list
  const onGoingListLoading = useVisible(true);
  // end list
  const endListLoading = useVisible(true);

  const { isDeadpoolReady, isGray } = useDeadpool(DEADPOOLKEYS.depositEarnGray);

  const paginationState = usePagination();
  const onGoingPaginationState = usePagination();

  const { setOnGoingList, setEndList, setHeader, setActivityLoading, setHistoryLoading } = useList();

  const fetchOnGoingList = async () => {
    onGoingListLoading.open();
    try {
      const { result, ret_code } = await getOnGoingProjectList();
      if (ret_code === 0) {
        setOnGoingList(result || []);
        onGoingPaginationState.setTotal(result?.length || 0)
      }
    } catch (e) {
      console.error(e);
    } finally {
      onGoingListLoading.close();
      setActivityLoading(false);
    }
  };

  const fetchEndList = async () => {
    endListLoading.open();
    try {
      const { result, ret_code } = await getEndProjectList({
        pageNo: paginationState.current,
        pageSize: paginationState.pageSize,
      });
      if (ret_code === 0) {
        setEndList(result?.list || []);
        paginationState.setTotal(result?.total || 0);
      }
    } catch (e) {
      console.error(e);
    } finally {
      endListLoading.close();
      setHistoryLoading(false);
    }
  };

  const fetchHeader = async () => {
    headLoading.open();
    try {
      const { result = undefined, ret_code } = (await getHeader()) || {};
      if (ret_code === 0) {
        setHeader(result);
      }
    } catch (e) {
      console.error(e);
    } finally {
      headLoading.close();
    }
  };

  const init = () => {
    fetchOnGoingList();
    fetchHeader();
  };

  useEffect(() => {
    if (!isDeadpoolReady) {
      return;
    }
    if (isGray) {
      setHistoryLoading(false);
      return;
    }
    fetchEndList();
  }, [paginationState.current, isDeadpoolReady, isGray]);

  useEffect(() => {
    init();
  }, []);

  const isLoading = onGoingListLoading.visible || endListLoading.visible;

  return {
    ...paginationState,
    endPagination: paginationState,
    onGoingPaginationState,
    headLoading: headLoading.visible,
    isLoading,
    nextPage: paginationState.next,
    init,
  };
};
